/*eslint unicode-bom: ["error", "always"]*/
import * as React from 'react';
import { connect } from 'react-redux';
import * as microsoftTeams from "@microsoft/teams-js";
import { updateSelectedStation } from '../../actions';


interface IStationPickerProps {
    getStations?: any;
    getStationsList?: any;
    updateSelectedStation?: any;
    stations?: any[]
}

class StationPicker extends React.Component<IStationPickerProps> {

    constructor(props: IStationPickerProps) {
        super(props);
        this.handeStationChange = this.handeStationChange.bind(this);
    }
    public componentDidMount() {
        debugger;
    
        microsoftTeams.getContext((context) => {
            if (context.groupId) 
            this.props.updateSelectedStation(context.groupId);

        })

    }
    public render(): JSX.Element {
        return <></>
    }
    private handeStationChange(_: any, data: any) {
        const value = data.value || "";
        this.props.updateSelectedStation(value.header || "");
    }
}
const MapStateToProps = (state: any) => {
    return { stations: state.stations.stations }
}

export default connect(MapStateToProps, { updateSelectedStation })(StationPicker);